import styled from 'styled-components';

export const ContentArea = styled.div`
  max-width: ${p => p.theme.contentMaxWidth};
  width: 100%;
  padding: 16px;
  margin: 24px auto;
`;
